import { createActionTypes } from "../../helpers/utils/createActionTypes"

export const BUSINESS = {
    GET_LISTA_BUSINESS: createActionTypes("GET_LISTA_BUSINESS"),
    GET_BUSINESS: createActionTypes("GET_BUSINESS"),
    SAVE_BUSINESS: createActionTypes("SAVE_BUSINESS"),

    LOAD_EMPTY_BUSINESS: "LOAD_EMPTY_BUSINESS",
    CLEAN_MESSAGE_BUSINESS: "CLEAN_MESSAGE_BUSINESS",
    CHANGE_PAGE_SIZE_BUSINESS: "CHANGE_PAGE_SIZE_BUSINESS"
}